var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41340",
    "data-name": "Group 41340",
    transform: "translate(18058 1131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15683",
    "data-name": "Rectangle 15683",
    width: 40,
    height: 40,
    transform: "translate(-18058 -1131)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-18056.668 -1128.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_286463440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41336",
    "data-name": "Group 41336",
    transform: "translate(0 0.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37078",
    "data-name": "Path 37078",
    d: "M3.135,1050.793a.714.714,0,0,1-.722-.306L.05,1046.593a.681.681,0,0,1,.241-.918l2.538-1.531a.592.592,0,0,1,.5-.087.662.662,0,0,1,.416.306l2.363,3.872a.706.706,0,0,1-.241.941l-2.538,1.531A.775.775,0,0,1,3.135,1050.793Z",
    transform: "translate(0.038 -1022.407)",
    fill: "#ff9500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37080",
    "data-name": "Path 37080",
    d: "M409.624,91.329h-.066l-19.775,2.188a.706.706,0,0,1-.656-.328l-3.413-5.622a.7.7,0,0,1,.022-.744l11.047-16.516a.7.7,0,0,1,.591-.306.645.645,0,0,1,.547.328L410,90.213a.809.809,0,0,1,.153.306.659.659,0,0,1-.525.788Z",
    transform: "translate(-377.181 -69.681)",
    fill: "#ff9500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37082",
    "data-name": "Path 37082",
    d: "M371.762,1195.238a.661.661,0,0,1-.7-.328l-4.484-7.372a.67.67,0,0,1,.219-.919l2.494-1.531a.682.682,0,0,1,.5-.066.661.661,0,0,1,.416.306l4.484,7.372a.6.6,0,0,1,.088.5.659.659,0,0,1-.306.415l-2.494,1.532A.909.909,0,0,1,371.762,1195.238Z",
    transform: "translate(-358.461 -1160.29)",
    fill: "#d1131d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37084",
    "data-name": "Path 37084",
    d: "M68.5,791.457a.632.632,0,0,1-.284-.022.662.662,0,0,1-.416-.306l-4.659-7.678a.64.64,0,0,1-.088-.525.8.8,0,0,1,.306-.416l6.431-3.894a.662.662,0,0,1,.919.24l4.66,7.678a.7.7,0,0,1-.219.941l-6.431,3.894A.651.651,0,0,1,68.5,791.457Z",
    transform: "translate(-61.655 -762.699)",
    fill: "#d1131d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37086",
    "data-name": "Path 37086",
    d: "M817.331,78.192a2.625,2.625,0,0,1-3.587-.963L803.418,59.357a2.634,2.634,0,0,1,.963-3.588,2.6,2.6,0,0,1,3.588.963L818.293,74.6A2.6,2.6,0,0,1,817.331,78.192Z",
    transform: "translate(-785.501 -55.407)",
    fill: "#fee14d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41337",
    "data-name": "Group 41337",
    transform: "translate(27.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37087",
    "data-name": "Path 37087",
    d: "M1236.288,59.188a.643.643,0,0,1-.2-.044.42.42,0,0,1-.2-.569l2.363-4.856a.467.467,0,0,1,.59-.219.438.438,0,0,1,.2.591l-2.385,4.856A.4.4,0,0,1,1236.288,59.188Z",
    transform: "translate(-1235.847 -53.467)",
    fill: "#b2b9c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37088",
    "data-name": "Path 37088",
    d: "M1426.737,596.225h-.022l-5.4-.35a.421.421,0,0,1-.394-.459.44.44,0,0,1,.459-.416l5.381.372a.44.44,0,0,1,.415.459A.447.447,0,0,1,1426.737,596.225Z",
    transform: "translate(-1416.867 -583.154)",
    fill: "#b2b9c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37089",
    "data-name": "Path 37089",
    d: "M1315.016,341.925a.451.451,0,0,1-.372-.219.443.443,0,0,1,.153-.591l4.266-2.472a.455.455,0,0,1,.591.153.443.443,0,0,1-.153.591l-4.266,2.472A.423.423,0,0,1,1315.016,341.925Z",
    transform: "translate(-1312.869 -332.354)",
    fill: "#b2b9c4",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationColored);
export default __webpack_public_path__ + "static/media/notification-colored.215ee1022fb61583811563378311bdea.svg";
export { ForwardRef as ReactComponent };